import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'

export const ModelVariant = withFacetContext(
    FacetName.aggregated_trim,
    withFilterContext(FilterName.aggregated_trim, SearchFiltersDropdown, {
        title: 'Model variant',
    })
)
